module.exports = __webpack_public_path__ + "img/pro_one_2.21d3b6bc.jpg";